(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1650],{

/***/ 72129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ home_QuoteTable; }
});

// UNUSED EXPORTS: quotePropTypes

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(28677);
// EXTERNAL MODULE: ./src/utils/store/index.js + 10 modules
var store = __webpack_require__(26721);
// EXTERNAL MODULE: ./src/utils/api/sessionPass.js
var sessionPass = __webpack_require__(55275);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/echarts-for-react/esm/index.js + 555 modules
var echarts_for_react_esm = __webpack_require__(76483);
;// CONCATENATED MODULE: ./src/components/common/Chart/SimpleEchart.js





var options = {
    animation: false,
    xAxis: {
        type: "category",
        show: false
    },
    yAxis: {
        type: "value",
        min: "dataMin",
        show: false
    },
    grid: {
        left: 0,
        bottom: "35%",
        show: false
    },
    color: "#FFD140"
};
var serie = {
    type: "line",
    showSymbol: false,
    soomth: true,
    lineStyle: {
        width: 1
    },
    areaStyle: {
        normal: {
            color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                    {
                        offset: 0,
                        color: "#FFD140"
                    },
                    {
                        offset: 0.7,
                        color: "transparent"
                    }, 
                ],
                globalCoord: false
            }
        }
    }
};
function SimpleEChart(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(echarts_for_react_esm/* default */.Z, {
        option: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
            series: [
                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, serie), {
                    data: data
                })
            ]
        }),
        style: {
            width: "100%",
            height: "60px",
            position: "relative",
            top: "-20px"
        }
    });
}
SimpleEChart.propTypes = {
    data: prop_types_default().arrayOf((prop_types_default()).number)
};
SimpleEChart.defaultProps = {
    data: []
};
/* harmony default export */ var SimpleEchart = (SimpleEChart);

// EXTERNAL MODULE: ./src/components/pages/home/QuoteTable.module.scss
var QuoteTable_module = __webpack_require__(47084);
var QuoteTable_module_default = /*#__PURE__*/__webpack_require__.n(QuoteTable_module);
;// CONCATENATED MODULE: ./src/components/pages/home/QuoteTable.js











function Skeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: new Array(10).fill("").map(function(_, index) {
            return(// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                className: (QuoteTable_module_default()).skeleton,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (QuoteTable_module_default()).name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (QuoteTable_module_default()).chart
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (QuoteTable_module_default()).rate
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (QuoteTable_module_default()).price
                        })
                    })
                ]
            }, "skeleton-".concat(index)));
        })
    });
}
function Quote(param) {
    var quote = param.quote, isReverse = param.isReverse, chartData = param.chartData;
    var ref = (0,react.useState)(false), imgFallback = ref[0], setImgFallback = ref[1];
    var color = isReverse ? !quote.isUp : quote.isUp;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                className: (QuoteTable_module_default()).name,
                children: [
                    imgFallback ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (QuoteTable_module_default()).fallbackIcon,
                        children: quote.name[0]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            src: "https://nbt-ui.oss-cn-hongkong.aliyuncs.com/bt-ui/vmicon/".concat(quote.name, ".svg"),
                            alt: quote.name,
                            onError: function() {
                                return setImgFallback(true);
                            }
                        })
                    }),
                    quote.name
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: (QuoteTable_module_default()).chart,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleEchart, {
                    data: chartData
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: classnames_default()((QuoteTable_module_default()).rate, (0,_define_property/* default */.Z)({}, (QuoteTable_module_default()).raise, color)),
                children: "".concat(quote.isUp ? "+" : "").concat(quote.rate, "%")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: (QuoteTable_module_default()).price,
                children: quote.price
            })
        ]
    });
}
function QuoteTable(param) {
    var quotes = param.quotes, title = param.title, chartData = param.chartData;
    var t = (0,esm/* useTranslation */.$G)("pages", {
        keyPrefix: "home.market.table"
    }).t;
    var isReverse = (0,store/* useStore */.oR)().setting.isReverse;
    var handleRedirectTo = (0,react.useCallback)(function(e) {
        var dataset = e.currentTarget.dataset;
        (0,sessionPass/* default */.ZP)(dataset.path);
    }, []);
    var renderQuote = (0,react.useMemo)(function() {
        return quotes.map(function(quote) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                "data-path": "/trade/deal/".concat(quote.code),
                onClick: handleRedirectTo,
                className: (QuoteTable_module_default()).quoteRow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote, {
                    quote: quote,
                    isReverse: isReverse,
                    chartData: chartData[quote.symbol]
                })
            }, "".concat(title, "-").concat(quote.code));
        });
    }, [
        quotes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (QuoteTable_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (QuoteTable_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: (QuoteTable_module_default()).table,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                className: (QuoteTable_module_default()).nameCol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                className: (QuoteTable_module_default()).chartCol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                span: "2",
                                className: (QuoteTable_module_default()).priceCol
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            className: (QuoteTable_module_default()).header,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    children: t("name")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    children: t("trend")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    children: t("24diff")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    children: t("price")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: quotes.length ? renderQuote : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {})
                    })
                ]
            })
        ]
    });
}
var quotePropTypes = {
    price: (prop_types_default()).string,
    rate: (prop_types_default()).string,
    id: (prop_types_default()).string,
    name: (prop_types_default()).string,
    isUp: (prop_types_default()).bool,
    symbol: (prop_types_default()).string
};
Quote.propTypes = {
    quote: prop_types_default().shape(quotePropTypes).isRequired,
    chartData: prop_types_default().arrayOf((prop_types_default()).number),
    isReverse: (prop_types_default()).bool.isRequired
};
Quote.defaultProps = {
    chartData: []
};
QuoteTable.propTypes = {
    quotes: prop_types_default().arrayOf(prop_types_default().shape(quotePropTypes)).isRequired,
    title: (prop_types_default()).string.isRequired,
    chartData: prop_types_default().instanceOf(Object)
};
QuoteTable.defaultProps = {
    chartData: {}
};
/* harmony default export */ var home_QuoteTable = (QuoteTable);


/***/ }),

/***/ 91650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kz": function() { return /* reexport */ home_BasicInfo; },
  "TT": function() { return /* reexport */ home_FeatureCard; },
  "jy": function() { return /* reexport */ home_LicenseCard; },
  "Ct": function() { return /* reexport */ home_NewsBanner; },
  "zc": function() { return /* reexport */ home_Promotions; },
  "Yn": function() { return /* reexport */ home_QuickQuote; },
  "sc": function() { return /* reexport */ home_QuoteMarquee; },
  "tS": function() { return /* reexport */ home_TopGainers; },
  "Yz": function() { return /* reexport */ home_TopLosers; }
});

// UNUSED EXPORTS: QuoteTable

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/pages/home/FeatureCard.module.scss
var FeatureCard_module = __webpack_require__(51510);
var FeatureCard_module_default = /*#__PURE__*/__webpack_require__.n(FeatureCard_module);
;// CONCATENATED MODULE: ./src/components/pages/home/FeatureCard.js



function FeatureCard(param) {
    var Icon = param.Icon, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FeatureCard_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            })
        ]
    });
}
FeatureCard.propTypes = {
    Icon: (prop_types_default()).elementType.isRequired,
    title: (prop_types_default()).string.isRequired,
    description: (prop_types_default()).string.isRequired
};
/* harmony default export */ var home_FeatureCard = (FeatureCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(28677);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/Button/index.js + 1 modules
var Button = __webpack_require__(43412);
// EXTERNAL MODULE: ./src/components/pages/home/LicenseCard.module.scss
var LicenseCard_module = __webpack_require__(70130);
var LicenseCard_module_default = /*#__PURE__*/__webpack_require__.n(LicenseCard_module);
;// CONCATENATED MODULE: ./src/components/pages/home/LicenseCard.js









function LicenseCard(param) {
    var img = param.img, country = param.country, id = param.id, date = param.date, link = param.link, isVertical = param.isVertical;
    var t = (0,esm/* useTranslation */.$G)("pages", {
        keyPrefix: "home.license.card"
    }).t;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleClick = function() {
        return window.open(link, "_blank").focus();
    };
    var toggleShow = (0,react.useCallback)(function() {
        setShow(function(prevShow) {
            return !prevShow;
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (LicenseCard_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LicenseCard_module_default()).licenseFrame,
                "aria-hidden": "true",
                onClick: toggleShow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    className: classnames_default()((LicenseCard_module_default()).license, (0,_define_property/* default */.Z)({}, (LicenseCard_module_default()).vertical, isVertical)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: id,
                        layout: "responsive",
                        src: img
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (LicenseCard_module_default()).country,
                children: [
                    country,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("supervised")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LicenseCard_module_default()).licenseInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("id")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: id
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("issueDate")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: date
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((LicenseCard_module_default()).imageView, (0,_define_property/* default */.Z)({}, (LicenseCard_module_default()).modelShow, show)),
                "aria-hidden": "true",
                onClick: toggleShow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "".concat(id, "-view"),
                        layout: "fill",
                        objectFit: "contain",
                        src: img
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                className: (LicenseCard_module_default()).link,
                onClick: handleClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: link,
                    children: "".concat(country, " ").concat(t("verification"))
                })
            })
        ]
    });
}
LicenseCard.propTypes = {
    img: prop_types_default().instanceOf(Object).isRequired,
    country: (prop_types_default()).string.isRequired,
    id: (prop_types_default()).string.isRequired,
    date: (prop_types_default()).string.isRequired,
    link: (prop_types_default()).string.isRequired,
    isVertical: (prop_types_default()).bool
};
LicenseCard.defaultProps = {
    isVertical: false
};
/* harmony default export */ var home_LicenseCard = (LicenseCard);

// EXTERNAL MODULE: ./src/utils/hooks/useRequest.js
var useRequest = __webpack_require__(16314);
;// CONCATENATED MODULE: ./src/utils/hooks/usePromoteData.js


var requestConfig = {
    url: "/api/index.htm?action=carousel"
};
function usePromoteData() {
    var ref = (0,useRequest/* default */.Z)(requestConfig), data = ref.data, error = ref.error;
    var result = (0,react.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                done: true,
                data: data.carousels
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
/* harmony default export */ var hooks_usePromoteData = (usePromoteData);

// EXTERNAL MODULE: ./src/components/pages/home/Promotions.module.scss
var Promotions_module = __webpack_require__(97075);
var Promotions_module_default = /*#__PURE__*/__webpack_require__.n(Promotions_module);
;// CONCATENATED MODULE: ./src/components/pages/home/Promotions.js



function Promotions() {
    var ref = hooks_usePromoteData(), _data = ref.data, data = _data === void 0 ? [] : _data;
    var promotions = data.filter(function(banner) {
        return banner.expireTime >= Date.now() && banner.platform.includes("web");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Promotions_module_default()).container,
        children: promotions.map(function(promotion) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Promotions_module_default()).promotionCard,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: promotion.link || "#",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: promotion.url,
                        alt: promotion.name
                    })
                })
            }, promotion.id);
        })
    });
}
/* harmony default export */ var home_Promotions = (Promotions);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 17 modules
var mobxreact_esm = __webpack_require__(50828);
// EXTERNAL MODULE: ./src/utils/store/index.js + 10 modules
var utils_store = __webpack_require__(26721);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./src/utils/hooks/useSymbolInfo.js



var useSymbolList = function(symbol) {
    var _symbol = (0,utils_store/* useStore */.oR)().symbol, _tradeList = _symbol.tradeList, tradeList = _tradeList === void 0 ? {} : _tradeList, tmp = _symbol.rate, rates = tmp === void 0 ? {} : tmp;
    var symbolInfo = (0,react.useMemo)(function() {
        if (!tradeList[symbol] || !rates) return undefined;
        var currency = ((tradeList === null || tradeList === void 0 ? void 0 : tradeList[symbol]) || {}).currency;
        var rate = rates[currency];
        return (0,_object_spread/* default */.Z)({
            rate: rate
        }, (tradeList === null || tradeList === void 0 ? void 0 : tradeList[symbol]) || {});
    }, [
        tradeList,
        rates
    ]);
    return symbolInfo;
};
/* harmony default export */ var useSymbolInfo = (useSymbolList);

;// CONCATENATED MODULE: ./src/utils/hooks/useIndexData.js
/* eslint-disable no-console */ 


var useIndexData_requestConfig = {
    url: "mkpai/thirtyDayVolume"
};
function useIndexData() {
    var ref;
    var store = (ref = (0,utils_store/* useStore */.oR)()) === null || ref === void 0 ? void 0 : ref.savedInfo;
    var ref1 = (0,useRequest/* default */.Z)({
        // baseURL: store?.quoteDomainsUrl[0],
        baseURL: (store === null || store === void 0 ? void 0 : store.quoteDomainsUrl[0]) || "https://test-qts.bskbacekfjd.com/",
        url: useIndexData_requestConfig.url
    }), data = ref1.data, error = ref1.error;
    var result = (0,react.useMemo)(function() {
        if (error) {
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                done: true,
                data: data.data
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
/* harmony default export */ var hooks_useIndexData = (useIndexData);

// EXTERNAL MODULE: ./src/utils/functions/math.js
var math = __webpack_require__(75470);
// EXTERNAL MODULE: ./src/utils/hooks/useQuoteTableData.js + 1 modules
var useQuoteTableData = __webpack_require__(62072);
// EXTERNAL MODULE: ./src/components/pages/home/BasicInfo.module.scss
var BasicInfo_module = __webpack_require__(90572);
var BasicInfo_module_default = /*#__PURE__*/__webpack_require__.n(BasicInfo_module);
;// CONCATENATED MODULE: ./src/components/pages/home/BasicInfo.js






// import Slider from 'react-slick';








var Quote = (0,mobxreact_esm/* observer */.Pi)(function(param) {
    var symbol = param.symbol;
    var symbolInfo = useSymbolInfo(symbol);
    var _symbol = (0,utils_store/* useStore */.oR)().symbol, localCurrency = _symbol.currency;
    var isReverse = (0,utils_store/* useStore */.oR)().setting.isReverse;
    var quote = (0,utils_store/* useStore */.oR)().websocket.quote;
    var paddingData = !symbolInfo || !quote;
    var quoteData = (0,react.useMemo)(function() {
        if (paddingData) return undefined;
        var name = symbolInfo.name, currency = symbolInfo.currency, contractCode = symbolInfo.contractCode, exchangeRate = symbolInfo.rate;
        var symbolQuote = (quote === null || quote === void 0 ? void 0 : quote[contractCode]) || {};
        var isUp = symbolQuote.isUp > 0;
        var title = "".concat(name.replace(currency, ""), "/").concat(currency);
        var rate = "".concat(symbolQuote.prev < symbolQuote.price ? "+" : "").concat((0,math/* dayChangeRate */.J)(symbolQuote.prev, symbolQuote.price), "%");
        var price = symbolQuote.price;
        var fiat = "".concat(localCurrency === "CNY" ? "\xa5" : "$").concat(Number((symbolQuote.price * (exchangeRate || 1)).toFixed(8)));
        return {
            title: title,
            isUp: isReverse ? !isUp : isUp,
            price: price,
            rate: rate,
            fiat: fiat
        };
    }, [
        symbolInfo,
        quote,
        paddingData
    ]);
    return quoteData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (BasicInfo_module_default()).symbol,
                        children: quoteData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((BasicInfo_module_default()).priceRate, (0,_define_property/* default */.Z)({}, (BasicInfo_module_default()).rise, quoteData.isUp)),
                        children: quoteData.rate
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (BasicInfo_module_default()).price,
                children: [
                    "$",
                    quoteData.price
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (BasicInfo_module_default()).fiat,
                children: quoteData.fiat
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {});
});
Quote.propTypes = {
    symbol: (prop_types_default()).string.isRequired
};
function Skeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BasicInfo_module_default()).skeleton,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BasicInfo_module_default()).symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BasicInfo_module_default()).price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BasicInfo_module_default()).fiat
            })
        ]
    });
}
function BasicInfo() {
    var _allMarginList, _allMarginList1, _allMarginList2;
    // const symbolStore = useStore().symbol;
    // const group = symbolStore.groups?.['市值榜'] || [];
    var t = (0,esm/* useTranslation */.$G)("pages", {
        keyPrefix: "home"
    }).t;
    var ref = (0,useQuoteTableData/* default */.Z)(), spotArr = ref.spotArr, marginArr = ref.marginArr;
    var allMarginList = [];
    (_allMarginList = allMarginList).push.apply(_allMarginList, (0,_to_consumable_array/* default */.Z)(marginArr[1]));
    (_allMarginList1 = allMarginList).push.apply(_allMarginList1, (0,_to_consumable_array/* default */.Z)(marginArr[2]));
    (_allMarginList2 = allMarginList).push.apply(_allMarginList2, (0,_to_consumable_array/* default */.Z)(marginArr[3]));
    var total24hVol = 0;
    var spotTotalVol = 0;
    spotArr[1].forEach(function(item) {
        spotTotalVol += parseFloat(item.volume) * parseFloat(item.price);
    });
    // let marginTotalVol = 0;
    // allMarginList.forEach((item) => {
    //   marginTotalVol += (parseFloat(item.volume) * parseFloat(item.price));
    // });
    total24hVol = parseInt(Number(spotTotalVol), 10) || 0;
    if (total24hVol >= 100000000) {
        total24hVol = "".concat(parseFloat(Number(spotTotalVol) / Math.pow(10, 8)).toFixed(2), "B+");
    } else if (total24hVol >= 100000) {
        total24hVol = "".concat(parseFloat(Number(spotTotalVol) / Math.pow(10, 5)).toFixed(2), "M+");
    }
    var result = hooks_useIndexData({});
    var monthTransactionVol = parseInt(Number(result.data), 10) || 0;
    if (monthTransactionVol >= 100000000) {
        monthTransactionVol = "".concat(parseFloat(Number(result.data) / Math.pow(10, 8)).toFixed(2), "B+");
    } else if (monthTransactionVol >= 100000) {
        monthTransactionVol = "".concat(parseFloat(Number(result.data) / Math.pow(10, 5)).toFixed(2), "M+");
    }
    // const list = useMemo(() => {
    //   const listArray = [];
    //   let stash = [];
    //   group.forEach((symbol, index) => {
    //     stash.push(symbol);
    //     if (index && (!((index + 1) % 4) || index === group.length - 1)) {
    //       listArray.push(stash);
    //       stash = [];
    //     }
    //   });
    //   return listArray;
    // }, [group]);
    // const renderQuote = (list || []).map((row) => (
    //   <div key={`quote-row-${row[0]}`}>
    //     <div className={styles.quoteRow}>
    //       {row.map((symbol) => (
    //         <div key={`quote-${symbol}`}>
    //           <Quote symbol={symbol} />
    //         </div>
    //       ))}
    //     </div>
    //   </div>
    // ));
    // const renderSkeleton = useMemo(() => (
    //   <div className={classnames(styles.quoteList, styles.quoteRow)}>
    //     {new Array(5).fill('').map((_, index) => (
    //       // eslint-disable-next-line react/no-array-index-key
    //       <div key={`skeleton-${index}`}>
    //         <Skeleton />
    //       </div>
    //     ))}
    //   </div>
    // ));
    var renderBasicInfo = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (BasicInfo_module_default()).info,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (BasicInfo_module_default()).data,
                            children: total24hVol === 0 ? "-" : total24hVol
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (BasicInfo_module_default()).label,
                            children: t("banner.basicInfo.tradingVol")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (BasicInfo_module_default()).data,
                            children: monthTransactionVol === 0 ? "-" : monthTransactionVol
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (BasicInfo_module_default()).label,
                            children: t("banner.basicInfo.transactionVol")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (BasicInfo_module_default()).data,
                            children: "250+"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (BasicInfo_module_default()).label,
                            children: t("banner.basicInfo.products")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (BasicInfo_module_default()).data,
                            children: "1.25M"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (BasicInfo_module_default()).label,
                            children: t("banner.basicInfo.registeredUsers")
                        })
                    ]
                })
            ]
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BasicInfo_module_default()).container,
        children: renderBasicInfo
    });
}
/* harmony default export */ var home_BasicInfo = ((0,mobxreact_esm/* observer */.Pi)(BasicInfo));

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/utils/functions/common.js
var common = __webpack_require__(18942);
// EXTERNAL MODULE: ./src/utils/hooks/useH5StringBuilder.js
var useH5StringBuilder = __webpack_require__(82807);
// EXTERNAL MODULE: ./src/components/pages/home/QuickQuote.module.scss
var QuickQuote_module = __webpack_require__(15817);
var QuickQuote_module_default = /*#__PURE__*/__webpack_require__.n(QuickQuote_module);
;// CONCATENATED MODULE: ./src/components/pages/home/QuickQuote.js













var QuickQuote_Quote = (0,mobxreact_esm/* observer */.Pi)(function(param) {
    var symbol = param.symbol;
    var symbolInfo = useSymbolInfo(symbol);
    var _symbol = (0,utils_store/* useStore */.oR)().symbol, localCurrency = _symbol.currency;
    var isReverse = (0,utils_store/* useStore */.oR)().setting.isReverse;
    var quote = (0,utils_store/* useStore */.oR)().websocket.quote;
    var paddingData = !symbolInfo || !quote;
    var quoteData = (0,react.useMemo)(function() {
        if (paddingData) return undefined;
        var name = symbolInfo.name, currency = symbolInfo.currency, contractCode = symbolInfo.contractCode, exchangeRate = symbolInfo.rate;
        var symbolQuote = (quote === null || quote === void 0 ? void 0 : quote[contractCode]) || {};
        var isUp = symbolQuote.isUp > 0;
        var title = "".concat(name.replace(currency, ""), "/").concat(currency);
        var rate = "".concat(symbolQuote.isUp ? "+" : "").concat((0,math/* dayChangeRate */.J)(symbolQuote.prev, symbolQuote.price), "%");
        var price = symbolQuote.price;
        var fiat = "".concat(localCurrency === "CNY" ? "\xa5" : "$").concat(Number((symbolQuote.price * (exchangeRate || 1)).toFixed(8)));
        return {
            title: title,
            isUp: isReverse ? !isUp : isUp,
            price: price,
            rate: rate,
            fiat: fiat
        };
    }, [
        symbolInfo,
        quote,
        paddingData
    ]);
    return quoteData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (QuickQuote_module_default()).datas,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://nbt-ui.oss-cn-hongkong.aliyuncs.com/bt-ui/vmicon/".concat(quoteData.title.replace("/USDT", ""), ".svg"),
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (QuickQuote_module_default()).symbol,
                        children: quoteData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (QuickQuote_module_default()).price,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "$",
                                    quoteData.price
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((QuickQuote_module_default()).priceRate, (0,_define_property/* default */.Z)({}, (QuickQuote_module_default()).rise, quoteData.isUp)),
                                children: quoteData.rate
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickQuote_Skeleton, {});
});
QuickQuote_Quote.propTypes = {
    symbol: (prop_types_default()).string.isRequired
};
function QuickQuote_Skeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (QuickQuote_module_default()).skeleton,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuickQuote_module_default()).symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuickQuote_module_default()).price
            })
        ]
    });
}
function QuickQuote() {
    var createSubarrays = function createSubarrays(originalArray, displaySize) {
        var newArray = [];
        for(var i = 0; i < originalArray.length; i += displaySize){
            newArray.push(originalArray.slice(i, i + displaySize));
        }
        return newArray;
    };
    var jumpToPage = function jumpToPage(data) {
        var finalUrl = "";
        if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
            if (user) {
                finalUrl = "/trade/".concat(data.includes("_CC") ? "spot" : "deal", "/").concat(data);
            } else {
                finalUrl = "/trade/".concat(data.includes("_CC") ? "spotV2" : "margin", "/").concat(data);
            }
        } else {
            finalUrl = "".concat(phrase, "/").concat(data.includes("_CC") ? "spotQuote" : "trade", "/").concat(data).concat(referral);
        }
        window.location.href = finalUrl;
    };
    var ref;
    var symbolStore = (0,utils_store/* useStore */.oR)().symbol;
    var group = ((ref = symbolStore.groups) === null || ref === void 0 ? void 0 : ref["市值榜"]) || [];
    var ref1 = (0,react.useState)(0), currentWidth = ref1[0], setCurrentWidth = ref1[1];
    var user = (0,utils_store/* useStore */.oR)().auth.user;
    var ref2 = (0,useH5StringBuilder/* default */.Z)(), phrase = ref2.phrase, referral = ref2.referral;
    (0,react.useEffect)(function() {
        var updateWindowWidth = function() {
            setCurrentWidth(window.innerWidth);
        };
        window.addEventListener("resize", updateWindowWidth);
        updateWindowWidth();
        return function() {
            window.removeEventListener("resize", updateWindowWidth);
        };
    }, []);
    var list = (0,react.useMemo)(function() {
        var displaySize = 4;
        if (currentWidth < 420) {
            displaySize = 1;
        } else if (currentWidth < 768) {
            displaySize = 2;
        } else if (currentWidth < 1024) {
            displaySize = 3;
        } else {
            displaySize = 4;
        }
        var listArray = createSubarrays(group, displaySize);
        return listArray;
    }, [
        group,
        currentWidth
    ]);
    var renderQuote = (list || []).map(function(row) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuickQuote_module_default()).quoteRow,
                children: row.map(function(symbol) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (QuickQuote_module_default()).quoteBrick,
                        role: "button",
                        onClick: function() {
                            return jumpToPage(symbol);
                        },
                        onKeyDown: function() {
                            return jumpToPage(symbol);
                        },
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickQuote_Quote, {
                            symbol: symbol
                        })
                    }, "quote-".concat(symbol));
                })
            })
        }, "quote-row-".concat(row[0]));
    });
    var renderSkeleton = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((QuickQuote_module_default()).quoteList, (QuickQuote_module_default()).quoteRow),
            children: new Array(4).fill("").map(function(_, index) {
                return(// eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickQuote_Skeleton, {})
                }, "skeleton-".concat(index)));
            })
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (QuickQuote_module_default()).container,
        children: list.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
            infinite: true,
            autoplay: true,
            // vertical
            // verticalSwiping
            swipeToSlide: true,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            className: (QuickQuote_module_default()).quoteList,
            arrows: false,
            children: renderQuote
        }) : renderSkeleton
    });
}
/* harmony default export */ var home_QuickQuote = ((0,mobxreact_esm/* observer */.Pi)(QuickQuote));

// EXTERNAL MODULE: ./src/components/pages/home/QuoteTable.js + 1 modules
var QuoteTable = __webpack_require__(72129);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./src/components/pages/home/TopGainers.module.scss
var TopGainers_module = __webpack_require__(89531);
var TopGainers_module_default = /*#__PURE__*/__webpack_require__.n(TopGainers_module);
;// CONCATENATED MODULE: ./src/components/pages/home/TopGainers.js
/* eslint-disable react/no-array-index-key */ /* eslint-disable max-len */ 









// import reRouteTo from '@/utils/api/sessionPass';





var TopGainers_Quote = (0,mobxreact_esm/* observer */.Pi)(function(props) {
    var data = props.data, page = props.page, first = props.first;
    var quote = (0,utils_store/* useStore */.oR)().websocket.quote;
    var paddingData = !quote;
    var isReverse = (0,utils_store/* useStore */.oR)().setting.isReverse;
    var t = (0,es/* useTranslation */.$G)("pages", {
        keyPrefix: "markets"
    }).t;
    var quoteData = (0,react.useMemo)(function() {
        if (paddingData) return undefined;
        var isUp = data.isUp > 0;
        var title = "".concat(data.name);
        var rate = "".concat(data.isUp ? "+" : "").concat(data.rate, "%");
        var price = data.price, isOpen = data.isOpen, originName = data.originName;
        return {
            title: title,
            isUp: isReverse ? !isUp : isUp,
            price: price,
            rate: rate,
            isOpen: isOpen,
            originName: originName
        };
    }, [
        quote,
        paddingData
    ]);
    return quoteData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TopGainers_module_default()).datas,
        children: page === "smallMarkets" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopGainers_module_default()).nameLabel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://nbt-ui.oss-cn-hongkong.aliyuncs.com/bt-ui/vmicon/".concat(quoteData.originName, ".svg"),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (TopGainers_module_default()).symbol,
                            children: quoteData.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TopGainers_module_default()).priceLabel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "$",
                            quoteData.price
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TopGainers_module_default()).changeLabel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((TopGainers_module_default()).priceRate, (0,_define_property/* default */.Z)({}, (TopGainers_module_default()).rise, quoteData.isUp)),
                        children: quoteData.rate
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                first && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: data.index < 9 ? (TopGainers_module_default()).ranking : (TopGainers_module_default()).lastRanking,
                    children: data.index + 1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://nbt-ui.oss-cn-hongkong.aliyuncs.com/bt-ui/vmicon/".concat(quoteData.originName, ".svg"),
                    alt: ""
                }),
                page === "tradingData" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopGainers_module_default()).tradingData,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (TopGainers_module_default()).title,
                            children: quoteData.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (TopGainers_module_default()).price,
                            children: [
                                "$",
                                quoteData.price
                            ]
                        }),
                        quoteData.isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()((TopGainers_module_default()).rate, (0,_define_property/* default */.Z)({}, (TopGainers_module_default()).rise, quoteData.isUp)),
                            children: quoteData.rate
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()((TopGainers_module_default()).rate, (TopGainers_module_default()).grey),
                            children: t("markets.label.close")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopGainers_module_default()).markets,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (TopGainers_module_default()).symbol,
                                children: quoteData.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TopGainers_module_default()).price,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "$",
                                        quoteData.price
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()((TopGainers_module_default()).priceRate, (0,_define_property/* default */.Z)({}, (TopGainers_module_default()).rise, quoteData.isUp)),
                                    children: quoteData.rate
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TopGainers_Skeleton, {});
});
function TopGainers_Skeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TopGainers_module_default()).skeleton,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TopGainers_module_default()).symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TopGainers_module_default()).price
            })
        ]
    });
}
function TopGainers(props) {
    var createSubarrays = function createSubarrays(originalArray, displaySize) {
        var newArray = [];
        for(var i = 0; i < originalArray.length; i += displaySize){
            newArray.push(originalArray.slice(i, i + displaySize));
        }
        return newArray;
    };
    var jumpToPage = function jumpToPage(data) {
        var finalUrl = "";
        if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
            if (user) {
                finalUrl = "/trade/".concat(data.code.includes("_CC") ? "spot" : "deal", "/").concat(data.id);
            } else {
                finalUrl = "/trade/".concat(data.code.includes("_CC") ? "spotV2" : "margin", "/").concat(data.id);
            }
        } else {
            // reRouteTo(`${phrase}/${data.code.includes('_CC') ? 'trade' : `spotQuote/${data.id}`}`);
            finalUrl = "".concat(phrase, "/").concat(data.code.includes("_CC") ? "spotQuote" : "trade", "/").concat(data.id).concat(referral);
        }
        window.location.href = finalUrl;
    };
    var page = props.page, first = props.first;
    var tabList = (0,useQuoteTableData/* default */.Z)().tabList;
    var ref = (0,react.useState)(0), currentWidth = ref[0], setCurrentWidth = ref[1];
    var user = (0,utils_store/* useStore */.oR)().auth.user;
    var ref1 = (0,useH5StringBuilder/* default */.Z)(), phrase = ref1.phrase, referral = ref1.referral;
    var className;
    if (page === "markets") {
        className = (TopGainers_module_default()).quoteColumn;
    } else if (page === "tradingData") {
        className = classnames_default()((TopGainers_module_default()).quoteColumn, (TopGainers_module_default()).tradingData);
    } else if (page === "smallMarkets") {
        className = (TopGainers_module_default()).quoteColumnSmall;
    } else {
        className = (TopGainers_module_default()).quoteRow;
    }
    (0,react.useEffect)(function() {
        var updateWindowWidth = function() {
            setCurrentWidth(window.innerWidth);
        };
        window.addEventListener("resize", updateWindowWidth);
        updateWindowWidth();
        return function() {
            window.removeEventListener("resize", updateWindowWidth);
        };
    }, []);
    var list = (0,react.useMemo)(function() {
        var listArray = [];
        var stash = [];
        var displaySize = 4;
        if (currentWidth < 400) {
            displaySize = 1;
        } else if (currentWidth < 768) {
            displaySize = 2;
        } else if (currentWidth < 1024) {
            displaySize = 3;
        } else {
            displaySize = 4;
        }
        tabList[0].forEach(function(content, index) {
            var contentWithIndex = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, content), {
                index: index
            });
            stash.push(contentWithIndex);
            if (page === "tradingData") {
                if (index && index < 10) {
                    listArray.push(stash);
                    stash = [];
                }
            } else if (page === "markets" || page === "smallMarkets") {
                if (index && index < 4) {
                    listArray.push(stash);
                    stash = [];
                }
            } else {
                listArray = createSubarrays(tabList[0], displaySize);
            }
        });
        return listArray;
    }, [
        tabList[0],
        currentWidth
    ]);
    var renderQuote = (list || []).map(function(row, ind) {
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: row.map(function(data, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: (TopGainers_module_default()).quoteBrick,
                        role: "button",
                        onClick: function() {
                            return jumpToPage(data);
                        },
                        onKeyDown: function() {
                            return jumpToPage(data);
                        },
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopGainers_Quote, {
                            data: data,
                            page: page,
                            first: first
                        })
                    }, "quote-".concat(data === null || data === void 0 ? void 0 : data.name).concat(index));
                })
            })
        }, "quote-row-".concat((ref = row[0]) === null || ref === void 0 ? void 0 : ref.name).concat(ind));
    });
    var renderSkeleton = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((TopGainers_module_default()).quoteList, page === "markets" || page === "smallMarkets" || page === "tradingData" ? (TopGainers_module_default()).quoteColumn : (TopGainers_module_default()).quoteRow),
            children: new Array(page === "markets" || page === "smallMarkets" ? 4 : 4).fill("").map(function(_) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopGainers_Skeleton, {})
                }, "skeleton-".concat(_));
            })
        });
    });
    if (page === "markets" || page === "smallMarkets" || page === "tradingData") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (TopGainers_module_default()).container,
            children: list.length ? renderQuote : renderSkeleton
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TopGainers_module_default()).container,
        children: list.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
            infinite: true,
            autoplay: true,
            // vertical
            // verticalSwiping
            swipeToSlide: true,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            className: (TopGainers_module_default()).quoteList,
            arrows: false,
            children: renderQuote
        }) : renderSkeleton
    });
}
TopGainers.propTypes = {
    page: (prop_types_default()).string.isRequired,
    first: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var home_TopGainers = ((0,mobxreact_esm/* observer */.Pi)(TopGainers));

// EXTERNAL MODULE: ./src/components/pages/home/TopLosers.module.scss
var TopLosers_module = __webpack_require__(22244);
var TopLosers_module_default = /*#__PURE__*/__webpack_require__.n(TopLosers_module);
;// CONCATENATED MODULE: ./src/components/pages/home/TopLosers.js
/* eslint-disable react/no-array-index-key */ /* eslint-disable max-len */ 












var TopLosers_Quote = (0,mobxreact_esm/* observer */.Pi)(function(props) {
    var data = props.data, page = props.page;
    var quote = (0,utils_store/* useStore */.oR)().websocket.quote;
    var paddingData = !quote;
    var isReverse = (0,utils_store/* useStore */.oR)().setting.isReverse;
    var t = (0,es/* useTranslation */.$G)("pages", {
        keyPrefix: "markets"
    }).t;
    var quoteData = (0,react.useMemo)(function() {
        if (paddingData) return undefined;
        var isUp = data.isUp > 0;
        var title = "".concat(data.name);
        var rate = "".concat(data.rate, "%");
        var price = data.price, isOpen = data.isOpen, originName = data.originName;
        return {
            title: title,
            isUp: isReverse ? !isUp : isUp,
            price: price,
            rate: rate,
            isOpen: isOpen,
            originName: originName
        };
    }, [
        quote,
        paddingData
    ]);
    return quoteData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TopLosers_module_default()).datas,
        children: page === "smallMarkets" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopLosers_module_default()).nameLabel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://nbt-ui.oss-cn-hongkong.aliyuncs.com/bt-ui/vmicon/".concat(quoteData.originName, ".svg"),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (TopLosers_module_default()).symbol,
                            children: quoteData.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TopLosers_module_default()).priceLabel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "$",
                            quoteData.price
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TopLosers_module_default()).changeLabel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((TopLosers_module_default()).priceRate, (0,_define_property/* default */.Z)({}, (TopLosers_module_default()).rise, quoteData.isUp)),
                        children: quoteData.rate
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://nbt-ui.oss-cn-hongkong.aliyuncs.com/bt-ui/vmicon/".concat(quoteData.originName, ".svg"),
                    alt: ""
                }),
                page === "tradingData" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopLosers_module_default()).tradingData,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (TopLosers_module_default()).title,
                            children: quoteData.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (TopLosers_module_default()).price,
                            children: [
                                "$",
                                quoteData.price
                            ]
                        }),
                        quoteData.isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()((TopLosers_module_default()).rate, (0,_define_property/* default */.Z)({}, (TopLosers_module_default()).rise, quoteData.isUp)),
                            children: quoteData.rate
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()((TopLosers_module_default()).rate, (TopLosers_module_default()).grey),
                            children: t("markets.label.close")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopLosers_module_default()).markets,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (TopLosers_module_default()).symbol,
                                children: quoteData.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TopLosers_module_default()).price,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "$",
                                        quoteData.price
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()((TopLosers_module_default()).priceRate, (0,_define_property/* default */.Z)({}, (TopLosers_module_default()).rise, quoteData.isUp)),
                                    children: quoteData.rate
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TopLosers_Skeleton, {});
});
function TopLosers_Skeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TopLosers_module_default()).skeleton,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TopLosers_module_default()).symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TopLosers_module_default()).price
            })
        ]
    });
}
function TopLosers(props) {
    var createSubarrays = function createSubarrays(originalArray, displaySize) {
        var newArray = [];
        for(var i = 0; i < originalArray.length; i += displaySize){
            newArray.push(originalArray.slice(i, i + displaySize));
        }
        return newArray;
    };
    var jumpToPage = function jumpToPage(data) {
        var finalUrl = "";
        if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
            if (user) {
                finalUrl = "/trade/".concat(data.code.includes("_CC") ? "spot" : "deal", "/").concat(data.id);
            } else {
                finalUrl = "/trade/".concat(data.code.includes("_CC") ? "spotV2" : "margin", "/").concat(data.id);
            }
        } else {
            finalUrl = "".concat(phrase, "/").concat(data.code.includes("_CC") ? "spotQuote" : "trade", "/").concat(data.id).concat(referral);
        }
        window.location.href = finalUrl;
    };
    var page = props.page;
    var tabList = (0,useQuoteTableData/* default */.Z)().tabList;
    var ref = (0,react.useState)(0), currentWidth = ref[0], setCurrentWidth = ref[1];
    var user = (0,utils_store/* useStore */.oR)().auth.user;
    var ref1 = (0,useH5StringBuilder/* default */.Z)(), phrase = ref1.phrase, referral = ref1.referral;
    var className;
    if (page === "markets") {
        className = (TopLosers_module_default()).quoteColumn;
    } else if (page === "tradingData") {
        className = classnames_default()((TopLosers_module_default()).quoteColumn, (TopLosers_module_default()).tradingData);
    } else if (page === "smallMarkets") {
        className = (TopLosers_module_default()).quoteColumnSmall;
    } else {
        className = (TopLosers_module_default()).quoteRow;
    }
    (0,react.useEffect)(function() {
        var updateWindowWidth = function() {
            setCurrentWidth(window.innerWidth);
        };
        window.addEventListener("resize", updateWindowWidth);
        updateWindowWidth();
        return function() {
            window.removeEventListener("resize", updateWindowWidth);
        };
    }, []);
    var list = (0,react.useMemo)(function() {
        var listArray = [];
        var stash = [];
        var displaySize = 4;
        if (currentWidth < 420) {
            displaySize = 1;
        } else if (currentWidth < 768) {
            displaySize = 2;
        } else if (currentWidth < 1024) {
            displaySize = 3;
        } else {
            displaySize = 4;
        }
        tabList[1].forEach(function(content, index) {
            stash.push(content);
            if (page === "tradingData") {
                if (index && index < 10) {
                    listArray.push(stash);
                    stash = [];
                }
            } else if (page === "markets" || page === "smallMarkets") {
                if (index && index < 4) {
                    listArray.push(stash);
                    stash = [];
                }
            } else {
                listArray = createSubarrays(tabList[1], displaySize);
            }
        });
        return listArray;
    }, [
        tabList[1]
    ]);
    var renderQuote = (list || []).map(function(row, ind) {
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: row.map(function(data, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: (TopLosers_module_default()).quoteBrick,
                        role: "button",
                        onClick: function() {
                            return jumpToPage(data);
                        },
                        onKeyDown: function() {
                            return jumpToPage(data);
                        },
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopLosers_Quote, {
                            data: data,
                            page: page
                        })
                    }, "quote-".concat(data === null || data === void 0 ? void 0 : data.name).concat(index));
                })
            })
        }, "quote-row-".concat((ref = row[0]) === null || ref === void 0 ? void 0 : ref.name).concat(ind));
    });
    var renderSkeleton = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((TopLosers_module_default()).quoteList, page === "markets" || page === "smallMarkets" || page === "tradingData" ? (TopLosers_module_default()).quoteColumn : (TopLosers_module_default()).quoteRow),
            children: new Array(page === "markets" || page === "smallMarkets" ? 4 : 4).fill("").map(function(_) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopLosers_Skeleton, {})
                }, "skeleton-".concat(_));
            })
        });
    });
    if (page === "markets" || page === "smallMarkets" || page === "tradingData") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (TopLosers_module_default()).container,
            children: list.length ? renderQuote : renderSkeleton
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TopLosers_module_default()).container,
        children: list.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
            infinite: true,
            autoplay: true,
            // vertical
            // verticalSwiping
            swipeToSlide: true,
            // draggable={false}
            slidesToShow: 1,
            slidesToScroll: 1,
            className: (TopLosers_module_default()).quoteList,
            arrows: false,
            children: renderQuote
        }) : renderSkeleton
    });
}
TopLosers.propTypes = {
    page: (prop_types_default()).string.isRequired
};
/* harmony default export */ var home_TopLosers = ((0,mobxreact_esm/* observer */.Pi)(TopLosers));

// EXTERNAL MODULE: ./src/utils/hooks/news/useNoticeData.js
var useNoticeData = __webpack_require__(81264);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/api/sessionPass.js
var sessionPass = __webpack_require__(55275);
// EXTERNAL MODULE: ./src/components/pages/center/imgs/SideBarIcon.js
var SideBarIcon = __webpack_require__(89290);
// EXTERNAL MODULE: ./src/components/pages/home/NewsBanner.module.scss
var NewsBanner_module = __webpack_require__(37991);
var NewsBanner_module_default = /*#__PURE__*/__webpack_require__.n(NewsBanner_module);
;// CONCATENATED MODULE: ./src/components/pages/home/NewsBanner.js











function NewsBanner() {
    var duplicateArrayToNine = function duplicateArrayToNine(arr) {
        if (!arr) return [];
        var a = arr.filter(function(notice) {
            return notice.top === true;
        });
        if (a.length > 9) {
            a = a.filter(function(item, i) {
                return i < 9;
            });
        }
        if (a.length === 3 || a.length === 2) {
            a = a.concat(a);
        }
        var b = a.shift();
        a = [].concat(a).concat(b).filter(function(notice) {
            return notice;
        });
        return a;
    };
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)("pages", {
        keyPrefix: "news"
    }).t;
    var data = (0,useNoticeData/* default */.Z)().data;
    var ref = (0,useH5StringBuilder/* default */.Z)(), phrase = ref.phrase, referral = ref.referral;
    var newData = (0,react.useMemo)(function() {
        return duplicateArrayToNine(data);
    }, [
        data
    ]);
    var styleName = (0,react.useMemo)(function() {
        return "carousel".concat(newData.length);
    }, [
        newData
    ]);
    var routeFunction = function(notice) {
        if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
            router.push("/news/announcement/".concat(notice === null || notice === void 0 ? void 0 : notice.id));
        } else {
            (0,sessionPass/* default */.ZP)("".concat(phrase, "/notice").concat(referral));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (NewsBanner_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((NewsBanner_module_default()).carousel, " ").concat((NewsBanner_module_default())[styleName]),
            children: (newData || []).map(function(notice, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: (NewsBanner_module_default()).carouselItem,
                    onClick: function() {
                        return routeFunction(notice);
                    },
                    role: "presentation",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NewsBanner_module_default()).carouselHead,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBarIcon/* default */.Z, {
                                icon: "announcement"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NewsBanner_module_default()).carouselBody,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (NewsBanner_module_default()).indexTitle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "【".concat(t("announcement.type.".concat(notice === null || notice === void 0 ? void 0 : notice.type)), "】")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: notice === null || notice === void 0 ? void 0 : notice.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewsBanner_module_default()).index,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (NewsBanner_module_default()).date,
                                        children: "".concat(moment_default()(notice === null || notice === void 0 ? void 0 : notice.time).format("YYYY/MM/DD"))
                                    })
                                })
                            ]
                        })
                    ]
                }, "notice.title".concat(index + 1));
            })
        })
    });
}
/* harmony default export */ var home_NewsBanner = (NewsBanner);

// EXTERNAL MODULE: ./src/components/pages/home/QuoteMarquee.module.scss
var QuoteMarquee_module = __webpack_require__(58230);
var QuoteMarquee_module_default = /*#__PURE__*/__webpack_require__.n(QuoteMarquee_module);
;// CONCATENATED MODULE: ./src/components/pages/home/QuoteMarquee.js











var RenderQuote = function(param) {
    var list = param.list, jumpToPage = param.jumpToPage;
    return (list || []).map(function(row) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (QuoteMarquee_module_default()).quoteBrick,
            role: "button",
            onClick: function() {
                return jumpToPage(row.symbol);
            },
            onKeyDown: function() {
                return jumpToPage(row.symbol);
            },
            tabIndex: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (QuoteMarquee_module_default()).datas,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://nbt-ui.oss-cn-hongkong.aliyuncs.com/bt-ui/vmicon/".concat(row.originName, ".svg"),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (QuoteMarquee_module_default()).symbol,
                                children: row.currency ? "".concat(row.name, "/").concat(row.currency) : row.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (QuoteMarquee_module_default()).price,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "$",
                                            row.price
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classnames_default()((QuoteMarquee_module_default()).priceRate, (0,_define_property/* default */.Z)({}, (QuoteMarquee_module_default()).rise, row.isUp)),
                                        children: "".concat(row.rate, "%")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }, "quote-".concat(row.symbol));
    });
};
function QuoteMarquee_Skeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (QuoteMarquee_module_default()).skeleton,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuoteMarquee_module_default()).symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuoteMarquee_module_default()).price
            })
        ]
    });
}
function QuoteMarquee(param) {
    var popularTab = param.popularTab;
    var tabList = (0,useQuoteTableData/* default */.Z)().tabList;
    var user = (0,utils_store/* useStore */.oR)().auth.user;
    var ref = (0,useH5StringBuilder/* default */.Z)(), phrase = ref.phrase, referral = ref.referral;
    var tab = 4;
    if (popularTab === 0) {
        tab = 4;
    } else if (popularTab === 1) {
        tab = 0;
    } else {
        tab = 2;
    }
    var listArray = tabList[tab];
    var jumpToPage = function(data) {
        var finalUrl = "";
        if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
            if (user) {
                finalUrl = "/trade/".concat(data.includes("_CC") ? "spot" : "deal", "/").concat(data);
            } else {
                finalUrl = "/trade/".concat(data.includes("_CC") ? "spotV2" : "margin", "/").concat(data);
            }
        } else {
            finalUrl = "".concat(phrase, "/").concat(data.includes("_CC") ? "spotQuote" : "trade", "/").concat(data).concat(referral);
        }
        window.location.href = finalUrl;
    };
    var renderSkeleton = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((QuoteMarquee_module_default()).quoteList, (QuoteMarquee_module_default()).quoteRow),
            children: new Array(4).fill("").map(function(_, index) {
                return(// eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteMarquee_Skeleton, {})
                }, "skeleton-".concat(index)));
            })
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (QuoteMarquee_module_default()).container,
        children: (listArray === null || listArray === void 0 ? void 0 : listArray.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (QuoteMarquee_module_default()).marquee,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: popularTab === 0 ? (QuoteMarquee_module_default()).rotateMeDbl : (QuoteMarquee_module_default()).rotateMe,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderQuote, {
                        list: listArray,
                        jumpToPage: jumpToPage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderQuote, {
                        list: listArray,
                        jumpToPage: jumpToPage
                    })
                ]
            })
        }) : renderSkeleton
    });
}
QuoteMarquee.propTypes = {
    popularTab: (prop_types_default()).number.isRequired
};
/* harmony default export */ var home_QuoteMarquee = ((0,mobxreact_esm/* observer */.Pi)(QuoteMarquee));

;// CONCATENATED MODULE: ./src/components/pages/home/index.js
/* eslint-disable import/prefer-default-export */ 











/***/ }),

/***/ 75470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ dayChangeRate; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export, eqeqeq */ var dayChangeRate = function(prev, now) {
    if (Number.isNaN(prev) || Number.isNaN(now)) return undefined;
    if (prev == 0) return ((now - prev) * 100 / 1).toFixed(2);
    return ((now - prev) * 100 / prev).toFixed(2);
};


/***/ }),

/***/ 81264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16314);


var requestConfig = {
    url: "/api/discover/index.htm?type=1,2,3,4,5,6,7,8"
};
function useNoticeData() {
    var ref = (0,_useRequest__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(requestConfig), data = ref.data, error = ref.error;
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                done: true,
                data: ((data === null || data === void 0 ? void 0 : data.notices) || []).sort(function(a, b) {
                    if (a.top === true && b.top === false) return -1;
                    if (a.top === false && b.top === true) return 1;
                    if (a.time < b.time) return 1;
                    return -1;
                })
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
/* harmony default export */ __webpack_exports__["Z"] = (useNoticeData);


/***/ }),

/***/ 62072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useQuoteTableData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/store/index.js + 10 modules
var store = __webpack_require__(26721);
// EXTERNAL MODULE: ./src/utils/hooks/useRequest.js
var useRequest = __webpack_require__(16314);
;// CONCATENATED MODULE: ./src/utils/hooks/useBitcastListData.js


var requestConfig = {
    url: "/api/quiz/commodity"
};
function useBitcastListData() {
    var ref = (0,useRequest/* default */.Z)(requestConfig), data = ref.data, error = ref.error;
    var result = (0,react.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                done: true,
                data: data
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result.data;
}
/* harmony default export */ var hooks_useBitcastListData = (useBitcastListData);

// EXTERNAL MODULE: ./src/utils/functions/math.js
var math = __webpack_require__(75470);
// EXTERNAL MODULE: ./src/utils/functions/rest.js
var rest = __webpack_require__(7021);
// EXTERNAL MODULE: ./src/utils/functions/common.js
var common = __webpack_require__(18942);
;// CONCATENATED MODULE: ./src/utils/hooks/useQuoteTableData.js









var rateSorter = function(a, b) {
    return Number(b.rate) - Number(a.rate);
};
// const volumeSorter = (a, b) => Number(a.sellVolume) + Number(a.buyVolume) - Number(b.sellVolume) - Number(b.buyVolume);
var volumeSorter = function(a, b) {
    return parseFloat(b.volume) * parseFloat(b.price) - parseFloat(a.volume) * parseFloat(a.price);
};
var useQuoteTableData = function() {
    var saveInfo = (0,store/* useStore */.oR)().savedInfo;
    var user = (0,store/* useStore */.oR)().auth.user;
    var quote = (0,store/* useStore */.oR)().websocket.quote;
    var _symbol = (0,store/* useStore */.oR)().symbol, groups = _symbol.groups, codes = _symbol.codes, tradeList = _symbol.tradeList;
    var bitcastObject = hooks_useBitcastListData();
    var isOpenV = (0,react.useCallback)(function(contract) {
        if (!tradeList[contract.code]) return contract;
        // todo: add isOpen
        return contract;
    }, [
        tradeList
    ]);
    var quoteTableData = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!quote || !groups || !codes || !tradeList) {
            return {
                tabList: [
                    [],
                    [],
                    [],
                    [],
                    []
                ],
                marketTableList: [
                    [],
                    [],
                    [],
                    []
                ],
                spotArr: [
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    []
                ],
                marginArr: [
                    [],
                    [],
                    [],
                    []
                ]
            };
        }
        var quoteWithRate = Object.entries(tradeList).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            var ref, ref1;
            var obj = {};
            if (!quote[value.contractCode]) {
                obj.buyPrice = "0.0";
                obj.buyVolume = "0.0";
                obj.isUp = "1";
                obj.max = "0.0";
                obj.min = "0.0";
                obj.prev = "0.0";
                obj.price = "0.0";
                obj.sellPrice = "0.0";
                obj.sellVolume = "0.0";
                obj.volume = "0.0";
                obj.socketData = false;
            } else {
                obj = quote[value.contractCode];
                obj.socketData = true;
            }
            obj.name = value.name ? (0,common/* getTradeListName */.vh)((ref = value.name) === null || ref === void 0 ? void 0 : ref.replace(value === null || value === void 0 ? void 0 : value.currency, "")) : value.code;
            obj.originName = value.name ? (0,common/* getTradeListName */.vh)((ref1 = value.name) === null || ref1 === void 0 ? void 0 : ref1.replace(value === null || value === void 0 ? void 0 : value.currency, ""), {
                imageSrc: true
            }) : "";
            obj.isOpen = rest/* default.isOpening */.Z.isOpening(value);
            obj.rate = (0,math/* dayChangeRate */.J)(obj.prev, obj.price);
            obj.isUp = obj.isUp > 0;
            obj.id = key;
            obj.code = value.code;
            obj.symbol = value.contractCode;
            obj.des = value.des;
            obj.crypto = value.crypto;
            obj.currency = value.currency;
            obj.contractCode = value.contractCode;
            return (0,_object_spread/* default */.Z)({}, obj);
        }).filter(function(e) {
            var ref, ref1, ref2, ref3, ref4;
            return (e === null || e === void 0 ? void 0 : (ref = e.id) === null || ref === void 0 ? void 0 : ref.indexOf("3S")) === -1 && (e === null || e === void 0 ? void 0 : (ref1 = e.id) === null || ref1 === void 0 ? void 0 : ref1.indexOf("3L")) === -1 && (e === null || e === void 0 ? void 0 : (ref2 = e.id) === null || ref2 === void 0 ? void 0 : ref2.indexOf("TWT")) === -1 && (e === null || e === void 0 ? void 0 : (ref3 = e.id) === null || ref3 === void 0 ? void 0 : ref3.indexOf("TWN")) === -1 && (e === null || e === void 0 ? void 0 : (ref4 = e.id) === null || ref4 === void 0 ? void 0 : ref4.indexOf("TMT")) === -1;
        });
        // const quoteWithRatea = Object.entries(quote).map(([key, value]) => {
        //   const rate = dayChangeRate(value.prev, value.price);
        //   const code = codes.contractCode[key];
        //   const isUp = value.isUp > 0;
        //   const name = code
        //     && (tradeList[code]?.name.includes('USD') ? tradeList[code].name : tradeList[code].code).replace(
        //       tradeList[code].currency,
        //       '',
        //     );
        //   const isOpen = rest.isOpening(tradeList[codes.contractCode[key]]);
        //   const des = tradeList[codes.contractCode[key]]?.des;
        //   const crypto = tradeList[codes.contractCode[key]]?.crypto;
        //   const currency = tradeList[codes.contractCode[key]]?.currency;
        //   return {
        //     ...value,
        //     isOpen,
        //     des,
        //     crypto,
        //     currency,
        //     rate,
        //     name,
        //     isUp,
        //     code,
        //     symbol: key,
        //   };
        // });
        var all = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.全部) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        });
        var main = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.主流区) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        });
        var hot = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.市值榜) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        });
        var rateSortedQuotes = all.sort(rateSorter);
        var volumeSortedQuotes = main.map(function(item) {
            return isOpenV(item);
        }).sort(volumeSorter);
        var raise = rateSortedQuotes.slice(0, 10);
        var fall = rateSortedQuotes.slice(-10).reverse();
        var fresh = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.NEW) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(rateSorter).slice(0, 10);
        var volume = volumeSortedQuotes.slice(0, 10);
        var symbols = Array.from(new Set((0,_to_consumable_array/* default */.Z)(all).concat((0,_to_consumable_array/* default */.Z)(main)).map(function(symbolQuote) {
            return symbolQuote.symbol;
        })));
        // faves
        var faveDb = JSON.parse(localStorage.getItem("favor_db")) || [];
        var faveCodes = "";
        if (!user) {
            faveCodes = "d";
        } else {
            faveCodes = user.userId;
        }
        if (faveDb[faveCodes] === undefined) faveCodes = "d";
        var faveSpot = quoteWithRate.filter(function(item) {
            var ref, ref1;
            return (ref = faveDb[faveCodes]) === null || ref === void 0 ? void 0 : (ref1 = ref.CT) === null || ref1 === void 0 ? void 0 : ref1.includes(item.code);
        }).map(function(item) {
            var newObj = (0,_object_spread/* default */.Z)({}, item);
            newObj.faveType = "CT";
            return newObj;
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var faveMargin = quoteWithRate.filter(function(item) {
            var ref, ref1;
            return (ref = faveDb[faveCodes]) === null || ref === void 0 ? void 0 : (ref1 = ref.FT) === null || ref1 === void 0 ? void 0 : ref1.includes(item.code);
        }).map(function(item) {
            var newObj = (0,_object_spread/* default */.Z)({}, item);
            newObj.faveType = "FT";
            return newObj;
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var faveBitcast = [];
        if ((ref = faveDb[faveCodes]) === null || ref === void 0 ? void 0 : ref.B) {
            var ref2;
            faveBitcast = (ref2 = faveDb[faveCodes]) === null || ref2 === void 0 ? void 0 : ref2.B.map(function(item) {
                return item.split("__");
            }).map(function(arr) {
                var obj = quoteWithRate.filter(function(item) {
                    var ref;
                    return (ref = arr[0]) === null || ref === void 0 ? void 0 : ref.includes(item.code);
                }) || {};
                if (obj[0]) {
                    var newObj = (0,_object_spread/* default */.Z)({}, obj[0]);
                    // eslint-disable-next-line prefer-destructuring
                    newObj.interval = arr[1];
                    newObj.faveType = "B";
                    return newObj;
                }
                return obj[0];
            }).filter(function(item) {
                return item;
            }).sort(function(a, b) {
                return a.name > b.name ? 1 : -1;
            });
        }
        var fave = faveSpot.concat(faveMargin).concat(faveBitcast).filter(function(item) {
            return item;
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        // spot
        var spot = quoteWithRate.filter(function(item) {
            var ref, ref1;
            return ((groups === null || groups === void 0 ? void 0 : (ref = groups.数字货币) === null || ref === void 0 ? void 0 : ref.includes(item.code)) || (groups === null || groups === void 0 ? void 0 : (ref1 = groups.全部) === null || ref1 === void 0 ? void 0 : ref1.includes(item.code))) && item.code.includes("_CC");
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var gray = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.Gray) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var defi = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.Defi) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var pos = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.POS) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var pow = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.POW) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var metaverse = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.METAVERSE) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var nft = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.NFT) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var polka = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.Polkadot) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var storage = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.存储) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var layers2 = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.LAYER2) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var bsc = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.BSC) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var animal = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.ANIMAL) === null || ref === void 0 ? void 0 : ref.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        // margin
        var marginSpecialList = quoteWithRate.filter(function(item) {
            var ref;
            return groups === null || groups === void 0 ? void 0 : (ref = groups.数字货币) === null || ref === void 0 ? void 0 : ref.includes(item.name);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var marginList = quoteWithRate.filter(function(item) {
            var ref;
            return (groups === null || groups === void 0 ? void 0 : (ref = groups.数字货币) === null || ref === void 0 ? void 0 : ref.includes(item.code)) && !item.code.includes("_CC");
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var deliveryItems = [];
        var ustockItems = [];
        saveInfo === null || saveInfo === void 0 ? void 0 : saveInfo.zones.forEach(function(item) {
            if (item.code === "deriv") {
                deliveryItems = (0,_to_consumable_array/* default */.Z)(new Set(item.list.split(";")));
            } else if (item.code === "ustock") {
                ustockItems = (0,_to_consumable_array/* default */.Z)(new Set(item.list.split(";")));
            }
        });
        var deliveryList = quoteWithRate.filter(function(item) {
            return deliveryItems.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var ustockList = quoteWithRate.filter(function(item) {
            return ustockItems.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        var crypto = (0,_to_consumable_array/* default */.Z)(marginSpecialList).concat((0,_to_consumable_array/* default */.Z)(marginList));
        var margin = (0,_to_consumable_array/* default */.Z)(crypto).concat((0,_to_consumable_array/* default */.Z)(deliveryList), (0,_to_consumable_array/* default */.Z)(ustockList));
        // isOpen
        Object.values(tradeList).forEach(function(item) {
            // eslint-disable-next-line no-param-reassign
            item.isOpen = rest/* default.isOpening */.Z.isOpening(item);
        });
        // bitcast
        var bitcastAllList = [];
        bitcastObject === null || bitcastObject === void 0 ? void 0 : (ref1 = bitcastObject.data) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(item) {
            bitcastAllList.push(item.code);
        });
        var bitcastList = (0,_to_consumable_array/* default */.Z)(new Set(bitcastAllList));
        var bitcast = quoteWithRate.filter(function(item) {
            return bitcastList.includes(item.code);
        }).sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
        });
        return {
            tabList: [
                raise,
                fall,
                fresh,
                volume,
                hot
            ],
            symbols: symbols,
            marketTableList: [
                fave,
                spot,
                margin,
                bitcast
            ],
            favourites: [
                fave,
                faveSpot,
                faveMargin,
                faveBitcast
            ],
            spotArr: [
                faveSpot,
                spot,
                gray,
                defi,
                pos,
                pow,
                metaverse,
                nft,
                polka,
                storage,
                layers2,
                bsc,
                animal
            ],
            marginArr: [
                faveMargin,
                crypto,
                deliveryList,
                ustockList
            ],
            tradeList: tradeList,
            bitcastCommodity: bitcastObject
        };
    }, [
        quote,
        groups,
        codes,
        tradeList
    ]);
    return (0,_object_spread/* default */.Z)({}, quoteTableData);
};
/* harmony default export */ var hooks_useQuoteTableData = (useQuoteTableData);


/***/ }),

/***/ 90572:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"BasicInfo_root_include_ru__iUx58","footer":"BasicInfo_footer__2Y9ak","container":"BasicInfo_container__JLZyb","quoteList":"BasicInfo_quoteList__NyyRq","skeleton":"BasicInfo_skeleton__r_dmC","breathing-color":"BasicInfo_breathing-color__6vyqj","symbol":"BasicInfo_symbol__FEkhe","price":"BasicInfo_price__vGe_D","fiat":"BasicInfo_fiat__kgVjS","quoteRow":"BasicInfo_quoteRow__JS3YG","priceRate":"BasicInfo_priceRate__zirf3","rise":"BasicInfo_rise__NXCv4","info":"BasicInfo_info__xZLJL","data":"BasicInfo_data__bcBr6","label":"BasicInfo_label__ShSY9"};

/***/ }),

/***/ 51510:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 70130:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"LicenseCard_container__W12m4","licenseFrame":"LicenseCard_licenseFrame__ngqIS","license":"LicenseCard_license__REv_J","vertical":"LicenseCard_vertical__REkK1","country":"LicenseCard_country__g6ycG","licenseInfo":"LicenseCard_licenseInfo__UMmnn","link":"LicenseCard_link__rOrwf","imageView":"LicenseCard_imageView__Dl0_E","modelShow":"LicenseCard_modelShow__lxuV0","zoom":"LicenseCard_zoom__wRqsX"};

/***/ }),

/***/ 37991:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsBanner_container__PJpK0","carousel":"NewsBanner_carousel__oCTrP","carouselItem":"NewsBanner_carouselItem__2xNru","carousel4":"NewsBanner_carousel4__IbLm0","carousel-animate-vertical4":"NewsBanner_carousel-animate-vertical4__eI6dw","carousel5":"NewsBanner_carousel5__5ODfG","carousel-animate-vertical5":"NewsBanner_carousel-animate-vertical5__fNFXT","carousel6":"NewsBanner_carousel6__owsOs","carousel-animate-vertical6":"NewsBanner_carousel-animate-vertical6__YmaTO","carousel7":"NewsBanner_carousel7__kbPyI","carousel-animate-vertical7":"NewsBanner_carousel-animate-vertical7__79f6U","carousel8":"NewsBanner_carousel8__UU_79","carousel-animate-vertical8":"NewsBanner_carousel-animate-vertical8__r_fYe","carousel9":"NewsBanner_carousel9__eDdQZ","carousel-animate-vertical9":"NewsBanner_carousel-animate-vertical9__5o24A","carouselHead":"NewsBanner_carouselHead__mdCSg","carouselBody":"NewsBanner_carouselBody__sQJxI","indexTitle":"NewsBanner_indexTitle__JjZd6","index":"NewsBanner_index__WEIvY","more":"NewsBanner_more__zoQGu"};

/***/ }),

/***/ 97075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Promotions_container__x2oeQ","promotionCard":"Promotions_promotionCard__MJmU_"};

/***/ }),

/***/ 15817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"QuickQuote_container__UQG9S","quoteList":"QuickQuote_quoteList__J3PQA","skeleton":"QuickQuote_skeleton__QC_JR","breathing-color":"QuickQuote_breathing-color__xWFH1","symbol":"QuickQuote_symbol__UgUKC","price":"QuickQuote_price__OJqB1","fiat":"QuickQuote_fiat__XCzKD","quoteRow":"QuickQuote_quoteRow__5dHoh","quoteBrick":"QuickQuote_quoteBrick__ef3ya","datas":"QuickQuote_datas__GyfRd","priceRate":"QuickQuote_priceRate__1Tv6R","rise":"QuickQuote_rise__wAbhZ"};

/***/ }),

/***/ 58230:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"QuoteMarquee_root_include_ru__1JLF7","footer":"QuoteMarquee_footer__pRgBI","container":"QuoteMarquee_container__ouOrp","quoteList":"QuoteMarquee_quoteList__vm1Tq","skeleton":"QuoteMarquee_skeleton__p3ZF8","breathing-color":"QuoteMarquee_breathing-color__Jlze0","symbol":"QuoteMarquee_symbol__uTCrH","price":"QuoteMarquee_price__XSTJ3","fiat":"QuoteMarquee_fiat__cJE_M","marquee":"QuoteMarquee_marquee__ypnWg","rotateMe":"QuoteMarquee_rotateMe__M0w_9","rotateMeDbl":"QuoteMarquee_rotateMeDbl__Su2gM","quoteBrick":"QuoteMarquee_quoteBrick__bU3ZE","datas":"QuoteMarquee_datas__p_YCM","priceRate":"QuoteMarquee_priceRate__F1YMO","rise":"QuoteMarquee_rise__uwcrr"};

/***/ }),

/***/ 47084:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"QuoteTable_container__rLNfZ","title":"QuoteTable_title__WXdex","table":"QuoteTable_table__6Drz2","header":"QuoteTable_header__3RQGh","skeleton":"QuoteTable_skeleton__ZiFMZ","breathing-color":"QuoteTable_breathing-color__Ld2UC","name":"QuoteTable_name__iDBzf","chart":"QuoteTable_chart__O8p2h","rate":"QuoteTable_rate__JBkQX","price":"QuoteTable_price___4SRO","quoteRow":"QuoteTable_quoteRow__2LeTg","fallbackIcon":"QuoteTable_fallbackIcon__mMUpz","raise":"QuoteTable_raise__lF_n_"};

/***/ }),

/***/ 89531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"TopGainers_root_include_ru__bnXhw","footer":"TopGainers_footer__78L6R","container":"TopGainers_container__hmvWW","quoteList":"TopGainers_quoteList__AUCv6","skeleton":"TopGainers_skeleton__d6z7i","breathing-color":"TopGainers_breathing-color__vFq7f","symbol":"TopGainers_symbol__F6ckE","price":"TopGainers_price__j2mef","fiat":"TopGainers_fiat__f09GU","quoteRow":"TopGainers_quoteRow__U9jhI","quoteBrick":"TopGainers_quoteBrick__WH6qn","datas":"TopGainers_datas__CFW8k","priceRate":"TopGainers_priceRate__FhAcx","rise":"TopGainers_rise__yxYxX","quoteColumn":"TopGainers_quoteColumn__qYx3U","ranking":"TopGainers_ranking__1Xrc8","lastRanking":"TopGainers_lastRanking__JxHh0","tradingData":"TopGainers_tradingData__KmccY","title":"TopGainers_title__x_3AJ","rate":"TopGainers_rate__UrkB_","grey":"TopGainers_grey__yQB3a","markets":"TopGainers_markets__vuVHV","quoteColumnSmall":"TopGainers_quoteColumnSmall__7mT1O","nameLabel":"TopGainers_nameLabel__nvsHp","priceLabel":"TopGainers_priceLabel__Us_OV","changeLabel":"TopGainers_changeLabel__Cr615"};

/***/ }),

/***/ 22244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"TopLosers_root_include_ru__txwSj","footer":"TopLosers_footer__Thr_R","container":"TopLosers_container__pnJqc","quoteList":"TopLosers_quoteList__jCzPf","skeleton":"TopLosers_skeleton__IEXTT","breathing-color":"TopLosers_breathing-color__4DzOG","symbol":"TopLosers_symbol__sZTCy","price":"TopLosers_price__rLUaJ","fiat":"TopLosers_fiat__hTXS3","quoteRow":"TopLosers_quoteRow__Gfw9s","quoteBrick":"TopLosers_quoteBrick__t96s4","datas":"TopLosers_datas__Fkkj8","priceRate":"TopLosers_priceRate__3AyTz","rise":"TopLosers_rise__aSCqI","quoteColumn":"TopLosers_quoteColumn__kK7fL","tradingData":"TopLosers_tradingData__jZEjC","title":"TopLosers_title__F6vEo","rate":"TopLosers_rate__5ckWF","grey":"TopLosers_grey__MuD3I","markets":"TopLosers_markets__JiuxJ","quoteColumnSmall":"TopLosers_quoteColumnSmall__ofR_c","nameLabel":"TopLosers_nameLabel__CBzJ1","priceLabel":"TopLosers_priceLabel__3OfFT","changeLabel":"TopLosers_changeLabel__K6JZR"};

/***/ })

}]);